import React, { useState, useRef, useEffect } from 'react'
import jump from 'jump.js'
import { SmallArrow } from 'src/components/svgs'

export interface TocItem {
  id: string
  label: string
}

export const FloatingToc = ({ items }: { items: TocItem[] }) => {
  const [isOpen, setIsOpen] = useState(false)
  const [isDismissed, setIsDismissed] = useState(false)
  const panelRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!isOpen) return

    const handleClickOutside = (e: MouseEvent) => {
      if (panelRef.current && !panelRef.current.contains(e.target as Node)) {
        setIsOpen(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [isOpen])

  const handleLinkClick = (id: string) => {
    setIsOpen(false)
    jump(`#${id}`, { offset: -100 })
    window.history.replaceState(null, '', `#${id}`)
  }

  const handleDismiss = (e: React.MouseEvent) => {
    e.stopPropagation()
    setIsOpen(false)
    setIsDismissed(true)
  }

  const handleRestore = () => {
    setIsDismissed(false)
  }

  if (isDismissed) {
    return (
      <div className="floating-toc floating-toc--dismissed">
        <button
          className="floating-toc__sliver"
          onClick={handleRestore}
          aria-label="Show Table of Contents"
        />
      </div>
    )
  }

  return (
    <div className="floating-toc" ref={panelRef}>
      <button
        className="floating-toc__tab"
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Table of Contents"
        aria-expanded={isOpen}
      >
        <span className="floating-toc__tab-text">Table of Contents</span>
      </button>
      <div
        className={`floating-toc__panel ${
          isOpen ? 'floating-toc__panel--open' : ''
        }`}
      >
        <button
          className="floating-toc__close"
          onClick={handleDismiss}
          aria-label="Close Table of Contents"
        >
          ×
        </button>
        <nav className="floating-toc__nav">
          {items.map(item => (
            <a
              key={item.id}
              href={`#${item.id}`}
              className="floating-toc__link"
              onClick={e => {
                e.preventDefault()
                handleLinkClick(item.id)
              }}
            >
              <SmallArrow className="floating-toc__arrow" />
              <span>{item.label}</span>
            </a>
          ))}
        </nav>
      </div>
    </div>
  )
}
